import { z } from "zod";

/// Legacy URL state for My surveys. The page used to be two tabs ("To answer" /
/// "Answered") driven by `tab`; the Answered view is now its own route at
/// /my-pulse/answered. The field stays in the schema so old links and bookmarks
/// still pass `.strict()` validation instead of erroring, and the route body
/// forwards `?tab=history` to the page that replaced it.
export const myPulseSearchSchema = z
  .object({
    tab: z.enum(["pending", "history"]).optional(),
  })
  .strict();

export type MyPulseSearch = z.infer<typeof myPulseSearchSchema>;
